import { useMutation } from '@tanstack/react-query'

import { pqClient } from '@/features/prequalification/localControl/endpoints/pqClient'
import type {
  ApiRunResourceSetResponse,
  RunResourceSetTestRequest,
} from '@/features/prequalification/localControl/types'
import type { UseMutationOptions } from '@/types/queries'

export type RunResourceSetTestVariables = { resourceSetId: string } & RunResourceSetTestRequest

export function useRunResourceSetTestMutation(
  options?: UseMutationOptions<ApiRunResourceSetResponse, RunResourceSetTestVariables>,
) {
  const { mutateAsync, ...mutationResult } = useMutation({
    ...options,
    mutationFn: ({ resourceSetId, ...request }: RunResourceSetTestVariables) =>
      pqClient.runResourceSetTest(resourceSetId, request),
  })

  return { runResourceSetTest: mutateAsync, ...mutationResult }
}
